import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import TooltipPortal from "../../../../../parts/tooltip-portal";
import { getTrackingForDay } from "../../../../../utils/daily-accountability";

const TRACKING_ICONS = {
  bodyWeight: "/img/new-icons/vuesax-linear-weight.svg",
  progressPhotos: "/img/new-icons/vuesax-linear-camera.svg",
  bodyMeasurements: "/img/new-icons/vuesax-linear-ruler.svg",
  mealPhotos: "/img/new-icons/meal.svg",
  readiness: "/img/new-icons/clipboard-notes.svg",
};

const TRACKING_I18N_KEYS = {
  bodyWeight: "calendar.cards.tracking.uploadBodyweight",
  progressPhotos: "calendar.cards.tracking.uploadProgressPictures",
  bodyMeasurements: "calendar.cards.tracking.uploadBodyMeasurements",
  mealPhotos: "calendar.cards.tracking.uploadMealPhotos",
  readiness: "calendar.cards.tracking.fillReadiness",
};

function PlanTrackingCard({ trackingItems, dayKey, hasTrainingOnDay }) {
  const { t } = useTranslation("athlete-portal");
  const trackingForDay = getTrackingForDay(trackingItems, dayKey, {
    hasTrainingOnDay,
  });
  const enabled = Object.keys(trackingForDay);
  if (enabled.length === 0) return null;
  return (
    <div className="plan-card plan-card--tracking">
      <div className="plan-card__header">
        <SvgIcon src="/img/new-icons/stats-chart.svg" useCurrentColor={true} />
        {t("calendar.cards.tracking.title")}
      </div>
      <div className="tracking-badges">
        {enabled.map((key) => {
          const label = TRACKING_I18N_KEYS[key]
            ? t(TRACKING_I18N_KEYS[key])
            : key;
          return (
            <TooltipPortal
              key={key}
              body={label}
              childrenContainerClass="tracking-badge"
              position="top"
            >
              <SvgIcon
                src={
                  TRACKING_ICONS[key] || "/img/new-icons/w-info-circle.svg"
                }
                useCurrentColor={true}
              />
            </TooltipPortal>
          );
        })}
      </div>
    </div>
  );
}

export default PlanTrackingCard;
